import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PublicHeader.css";
import downarrow from "../../Assets/images/downarrow.svg";
import userProfile from "../../Assets/images/user.png";
import NavigationHeading from "../../Utils/NavigationHeading/NavigationHeading";
import { performLogout } from "../../Utils/logoutHelper";

const PublicHeader = ({ content, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [headingTitle, setHeadingTitle] = useState("Invalid");

  const logout = async () => {
    await performLogout(navigate);
  };

  return (
    <>
      <div className="header-block">
        <div className="header-inner d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <div className="hamburger-icon" onClick={toggleSidebar}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                className="menu-icon"
              >
                <path
                  d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm4 17H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm0-4H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm0-4H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z"
                  fill="#e6e6e6"
                />
              </svg>
            </div>
            <NavigationHeading
              path={location.pathname}
              setHeadingTitle={setHeadingTitle}
            />
            <div className="header_title">{headingTitle}</div>
          </div>

          <div className="header-title">
            <div className="d-flex gap-3 header-content align-items-center">
              {/* <a className="bellicon-btn position-relative">
                <img src={bellicon} alt="bell-icon"></img>
                <div className="notification-digit">11</div>
              </a> */}
              <div class="nav-item dropdown">
                <div
                  class="nav-link dropdown-toggle d-flex align-items-center gap-2"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="profile-pic">
                    <img src={userProfile} alt=""></img>
                  </div>
                  <div className="down-arrow-div">
                    <img src={downarrow} alt="down-arrow"></img>
                  </div>

                </div>

                <ul class="dropdown-menu header-logout-box p-0">
                  <li>
                    <a
                      class="dropdown-item d-flex gap-2 align-items-center"
                      onClick={() => navigate("/user-profile")}
                    >
                      <div className="d-flex">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.0798 3.57894C11.0798 5.27939 9.70126 6.65788 8.00081 6.65788C6.30036 6.65788 4.92188 5.27939 4.92188 3.57894C4.92188 1.87849 6.30036 0.5 8.00081 0.5C9.70126 0.5 11.0798 1.87849 11.0798 3.57894Z"
                            stroke="#303030"
                          />
                          <path
                            d="M2.18457 14.3158C2.18457 11.1039 4.7884 8.5 8.00035 8.5C11.2123 8.5 13.8161 11.1039 13.8162 14.3158C13.8162 14.9698 13.286 15.5 12.6319 15.5H3.36879C2.71478 15.5 2.18457 14.9698 2.18457 14.3158Z"
                            stroke="#303030"
                          />
                        </svg>
                      </div>
                      <div className="logout-title" >
                        Profile
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item d-flex gap-2 align-items-center"
                      onClick={() => navigate("/settings")}
                    >
                      <div className="d-flex">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_670_6860)">
                            <path
                              d="M7.63513 11.3328C5.79713 11.3328 4.30176 9.83739 4.30176 7.99939C4.30176 6.16139 5.79713 4.66602 7.63513 4.66602C9.47304 4.66602 10.9684 6.16139 10.9684 7.99939C10.9684 9.83739 9.47307 11.3328 7.63513 11.3328ZM7.63513 5.66602C6.34841 5.66602 5.30176 6.71277 5.30176 7.99939C5.30176 9.28602 6.34841 10.3328 7.63513 10.3328C8.92176 10.3328 9.96838 9.28602 9.96838 7.99939C9.96838 6.71277 8.92176 5.66602 7.63513 5.66602Z"
                              fill="#303030"
                            />
                            <path
                              d="M8.74354 16H6.52614C5.99283 16 5.52151 15.6213 5.40551 15.0994L5.12489 13.8513C4.66748 13.6573 4.23145 13.4041 3.82217 13.0948L2.60682 13.4786C2.08545 13.6406 1.51883 13.4193 1.25745 12.9526L0.152231 11.0414C-0.11255 10.568 -0.023175 9.98534 0.366231 9.61866L1.30811 8.75269C1.27954 8.49866 1.26551 8.24672 1.26551 8C1.26551 7.75328 1.27957 7.50134 1.30751 7.24731L0.370856 6.38538C-0.0232063 6.01466 -0.113144 5.432 0.148825 4.96475L1.26089 3.04137C1.51883 2.57997 2.08682 2.36072 2.60486 2.52003L3.82217 2.90466C4.23145 2.59534 4.66748 2.34203 5.12489 2.14794L5.40614 0.898687C5.52151 0.378688 5.99283 0 6.52614 0H8.74354C9.27686 0 9.74817 0.378656 9.86417 0.900625L10.1448 2.14869C10.6022 2.34266 11.0382 2.59594 11.4475 2.90525L12.6628 2.52137C13.1856 2.36072 13.7509 2.58069 14.0122 3.04737L15.1176 4.95862C15.3822 5.432 15.2929 6.01466 14.9035 6.38134L13.9616 7.24731C13.9895 7.50134 14.0035 7.75403 14.0035 8C14.0035 8.24597 13.9895 8.49866 13.9616 8.75269L14.8988 9.614C14.9002 9.61534 14.9015 9.61669 14.9035 9.61806C15.0928 9.79594 15.217 10.0321 15.2564 10.2889C15.2959 10.5456 15.2481 10.8082 15.1209 11.0347L14.0088 12.958C13.7509 13.4193 13.1842 13.64 12.6642 13.4786L11.4468 13.094C11.0375 13.4033 10.6015 13.6566 10.1442 13.8507L9.86279 15.1C9.74817 15.6213 9.27689 16 8.74354 16ZM3.9242 12.0393C4.03883 12.0393 4.15151 12.0786 4.2422 12.1533C4.7002 12.53 5.19948 12.8207 5.72814 13.0154C5.80642 13.0442 5.87623 13.0922 5.9312 13.155C5.98618 13.2177 6.02456 13.2932 6.04286 13.3746L6.38223 14.8813C6.39748 14.9507 6.45817 15 6.52686 15H8.74417C8.81289 15 8.87354 14.9507 8.8882 14.8827L9.22817 13.3746C9.24646 13.2932 9.28484 13.2177 9.33981 13.155C9.39478 13.0922 9.46458 13.0442 9.54286 13.0154C10.0708 12.8207 10.5708 12.53 11.0288 12.1533C11.093 12.1001 11.1696 12.0638 11.2515 12.0478C11.3334 12.0319 11.418 12.0368 11.4975 12.062L12.9649 12.5254C13.0348 12.5474 13.1095 12.5213 13.1415 12.464L14.2535 10.5407C14.2869 10.4813 14.2748 10.4 14.2216 10.348L13.0962 9.31334C13.036 9.25804 12.9904 9.18882 12.9632 9.11177C12.936 9.03471 12.9281 8.95216 12.9402 8.87134C12.9841 8.57603 13.0062 8.28272 13.0062 7.99937C13.0062 7.71594 12.9841 7.42259 12.9402 7.12731C12.9281 7.0465 12.936 6.96396 12.9632 6.88692C12.9904 6.80987 13.0361 6.74065 13.0962 6.68531L14.2241 5.64794C14.2748 5.60072 14.2869 5.51794 14.2501 5.452L13.1448 3.54066C13.1089 3.47728 13.0329 3.45203 12.9635 3.474L11.4982 3.93666C11.3368 3.98803 11.1609 3.95338 11.0295 3.84534C10.5715 3.46863 10.0722 3.17797 9.54348 2.98328C9.4652 2.95445 9.3954 2.90647 9.34044 2.84371C9.28549 2.78095 9.24714 2.70543 9.22889 2.62403L8.88951 1.11731C8.87282 1.04931 8.81214 1 8.74354 1H6.52614C6.45754 1 6.39686 1.04931 6.3822 1.11731L6.04214 2.62538C6.02378 2.70672 5.98538 2.7822 5.93044 2.84493C5.8755 2.90767 5.80576 2.95569 5.72754 2.98463C5.19948 3.17931 4.69948 3.46997 4.2422 3.84669C4.11086 3.95472 3.93348 3.98866 3.77357 3.938L2.30617 3.47459C2.23757 3.45334 2.16151 3.47866 2.12954 3.536L1.01748 5.45862C0.984137 5.51869 0.996231 5.60131 1.05154 5.65331L2.17554 6.68603C2.2357 6.74135 2.28137 6.81057 2.30857 6.88763C2.33577 6.96469 2.34365 7.04724 2.33154 7.12806C2.28748 7.42334 2.26551 7.71669 2.26551 8C2.26551 8.28331 2.28748 8.57666 2.33154 8.87194C2.35623 9.036 2.29748 9.20131 2.17554 9.31397L1.04751 10.3513C0.996825 10.3987 0.984888 10.4813 1.02148 10.5474L2.12686 12.4586C2.16211 12.522 2.23817 12.5466 2.30811 12.5254L3.77357 12.0626C3.82289 12.0467 3.87357 12.0393 3.9242 12.0393Z"
                              fill="#303030"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_670_6860">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="logout-title">Settings</div>
                    </a>
                  </li>
                  <li>
                    <div
                      class="dropdown-item d-flex gap-2 align-items-center"
                      data-bs-toggle="modal"
                      data-bs-target="#logoutmodal"
                    >
                      <div className="d-flex">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.6106 9.29272C11.3345 9.29272 11.1106 9.51656 11.1106 9.79272V11.7445C11.1106 12.1215 10.804 12.4281 10.427 12.4281H7.80517V4.61731C7.80517 3.99956 7.49836 3.46816 6.96336 3.15925L3.22342 1H10.427C10.804 1 11.1106 1.30666 11.1106 1.68362V3.90991C11.1106 4.18606 11.3345 4.40991 11.6106 4.40991C11.8868 4.40991 12.1106 4.18606 12.1106 3.90991V1.68362C12.1106 0.755281 11.3554 0 10.427 0H2.54105C1.6127 0 0.857422 0.755281 0.857422 1.68362V12.2448C0.857422 12.8625 1.16423 13.3939 1.69923 13.7028L5.27973 15.77C5.54727 15.9244 5.83439 16.0017 6.12155 16.0017C6.40867 16.0016 6.69589 15.9244 6.96333 15.77C7.49833 15.4612 7.80514 14.9297 7.80514 14.312V13.4281H10.427C11.3554 13.4281 12.1106 12.6728 12.1106 11.7445V9.79272C12.1106 9.51656 11.8868 9.29272 11.6106 9.29272ZM6.80517 14.312C6.80517 14.5665 6.6838 14.7767 6.46336 14.904C6.24295 15.0312 6.00017 15.0312 5.77977 14.904L2.19923 12.8368C1.9788 12.7096 1.85742 12.4993 1.85742 12.2448V1.68362C1.85742 1.583 1.87927 1.48738 1.91848 1.40128L6.46336 4.02528C6.6838 4.15253 6.80517 4.36281 6.80517 4.61731V14.312ZM14.9953 7.06763L13.3706 8.69238C13.273 8.79 13.145 8.83884 13.017 8.83884C12.8891 8.83884 12.7611 8.79 12.6635 8.69238C12.4682 8.49713 12.4682 8.18053 12.6635 7.98528L13.4347 7.21406H8.84098C8.56486 7.21406 8.34098 6.99022 8.34098 6.71406C8.34098 6.43791 8.56486 6.21406 8.84098 6.21406H13.4347L12.6635 5.44284C12.4682 5.24759 12.4682 4.931 12.6635 4.73575C12.8588 4.54047 13.1754 4.54047 13.3706 4.73575L14.9954 6.3605C15.1906 6.55578 15.1906 6.87238 14.9953 7.06763Z"
                            fill="#303030"
                          />
                        </svg>
                      </div>
                      <div
                        className="logout-title"

                      >
                        Logout
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="logoutmodal"
        tabindex="-1"
        aria-labelledby="logoutLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered delete-modal">
          <div class="modal-content">
            <div class="modal-body pb-0">
              <div className="text-center delete-img-blk">
                {/* <img src={deleteimg} alt="delete-img"></img> */}
              </div>
              <div className="ques-title text-center logout-text">
                Logout Confirmation
                <p className="m-0">Are you sure you want to logout?</p>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
              <button
                type="button"
                class="gray-outline-btn"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="green-btn logout-btn"
                onClick={logout}
                data-bs-dismiss="modal"
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default PublicHeader;
